/* eslint-disable max-len */
import { CreateProfileFormType } from "./user-create.schema";
import { ICreateProfileRequest } from "./user-create.interface";

export const mapToProfileCreateRequest = (
  profile: CreateProfileFormType,
): ICreateProfileRequest => {
  return {
    firstName: profile.firstName.trim(),
    lastName: profile.lastName.trim(),
    phone: (profile.phone ?? "").replace("+1", "").replaceAll("-", "").replaceAll(" ", "") || "",
    hearAboutUs: profile.channelFoundUs|| "",
    placeId: profile.placeId || "",
    address: profile.address || "",
    addressInfo: {
      country: profile.country || "",
      streetAddress: profile.streetAddress || "",
      zipCode: profile.zipCode || "",
      townCity: profile.townCity || "",
    },
    location: profile.location||"",


  };
};
